import React from "react";
import { Row, Col, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import "./TherapistPatientsFilters.scss";

export function TherapistPatientsFilters({ search, sexo, onSearch, onSexo }) {
  // Namespace de la pantalla del paciente; el sexo se comparte con la ficha.
  const { t } = useTranslation("patient");

  return (
    <div className="revi-therapist-patient-filters">
      <Row gutter={[12, 12]}>
        <Col xs={24} md={16}>
          <Input
            value={search}
            placeholder={t("filtros.buscar")}
            onChange={(e) => onSearch(e.target.value)}
            allowClear
          />
        </Col>

        <Col xs={24} md={8}>
          <Select
            value={sexo ?? "ALL"}
            placeholder={t("filtros.sexoPlaceholder")}
            onChange={(v) => onSexo(v === "ALL" ? null : v)}
            allowClear
            style={{ width: "100%" }}
            options={[
              { value: "ALL", label: t("sexo.todos") },
              { value: "M", label: t("sexo.hombre") },
              { value: "F", label: t("sexo.mujer") },
              { value: "O", label: t("sexo.otro") },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
}
